import { useEffect, useState } from 'react';

export const getVideoHeight = (element, ratio, size) => {
  const [videoWidth, setVideoWidth] = useState(0);

  const handleResize = () => {
    element.current && setVideoWidth(element.current.clientWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    () => window.addEventListener('resize', handleResize);
  }, []);

  const sizes = {
    Small: '578',
    Medium: '784',
    Large: '990',
  };

  if (element.current && !videoWidth && element.current.clientWidth > 0) {
    setVideoWidth(element.current.clientWidth);
  }

  const width = size && sizes[size] < videoWidth ? sizes[size] : videoWidth;
  const height = width / ratio;

  return height;
};
